export default theme => ({
  card: {
    paddingTop: 10,
    [theme.breakpoints.only('xl')]: {
      width: 237,
    },
  },
  regularFontWeight: {
    fontWeight: 300,
  },
  paddingBox: {
    padding: '0 8px 8px',
  },
  paddingTop: {
    paddingTop: 8
  },
  paddingSmall: {
    paddingTop: 4
  },
  paddingBottom: {
    paddingBottom: 8
  },
  paddingBottomSmall: {
    paddingBottom: 4
  },
  paddingLeft: {
    paddingLeft: 5
  },
  marginLeft: {
    marginLeft: 10
  },
  iconButton: {
    padding: 0,
    '&:hover': {
      background: `${theme.palette.background.default}!important`
    },
    '&:focus': {
      background: `${theme.palette.background.default}!important`
    },
  },
  downloadIcon: {
    color: theme.palette.primary.blue,
    '&:hover': {
      color: `${theme.palette.primary.blue}!important`,
      background: `${theme.palette.background.default}!important`
    },
    '&:focus': {
      color: `${theme.palette.primary.blue}!important`,
      background: `${theme.palette.background.default}!important`
    },
  },
  disabledIcon: {
    cursor: 'default',
    filter: 'opacity(0.4)',
    '& img': {
      cursor: 'default',
    }
  },
  capitalize: {
    textTransform: 'capitalize'
  },
  inlineFlex: {
    display: 'inline-flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  },
  flexHeader: {
    alignItems: 'flex-start'
  },
  fixedWidth: {
    width: 'calc(100% - 30px)'
  },
  deleteButton: {
    minWidth: 24,
    height: 24,
    padding: 5,
    '&:hover': {
      background: `${theme.palette.background.default}!important`
    },
    '&:focus': {
      background: `${theme.palette.background.default}!important`
    },
  },
  expand: {
    transform: 'rotate(0deg)',
    padding: 0,
    '&:hover': {
      color: theme.palette.textColor.secondary,
      backgroundColor: '#fff',
    },
    '&:focus': {
      color: theme.palette.textColor.secondary,
      backgroundColor: '#fff',
    },
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  borderTop: {
    borderTop: `1px solid ${theme.palette.borderColor.primary}`,
  },
  actionsWrapper: {
    borderTop: `1px solid ${theme.palette.borderColor.primary}`,
    justifyContent: 'space-around',
    padding: 5,
    [theme.breakpoints.down('md')]: {
      paddingBottom: 0,
    },
  },
  linkText: {
    color: theme.palette.textColor.blue,
    cursor: 'pointer'
  },
  linkWrapper: {
    margin: '5px 0',
    cursor: 'pointer'
  },
  disabledLink: {
    margin: '5px 0',
    '& span': {
      color: theme.palette.textColor.secondary,
    }
  },
  defaultCursor: {
    cursor: 'auto'
  },
  sheetLocation: {
    fontSize: '0.75rem',
    display: 'flex',
    color: '#3E82FF',
    alignItems: 'center',
    marginTop: '-4px',
    marginBottom: '4px',
  },
  locationIcon: {
    width: '12px',
    marginRight: '4px',
    filter: 'invert(40%) sepia(72%) saturate(1866%) hue-rotate(205deg) brightness(101%) contrast(104%)'
  },
  flex: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  customPrev: {
    zIndex: 100,
    background: 'transparent',
    width: 24,
    height: 24,
    borderRadius: 15,
    backgroundColor: 'rgba(90, 135, 239, 0.1)',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.textColor.primary,
    cursor: 'pointer',
    transition: 'background 0.2s',
  },
  customNext: {
    zIndex: 100,
    background: 'transparent',
    width: 24,
    height: 24,
    borderRadius: 15,
    backgroundColor: 'rgba(90, 135, 239, 0.1)',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.textColor.primary,
    cursor: 'pointer',
    transition: 'background 0.2s',
  },
  customPaginationWrapper: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
  },
  customPagination: {
    justifyContent: 'center',
    width: 'auto !important',
    minWidth: '40px',
  }
});
